
export default function Comparison() {
  return (
    <section className="py-24 px-6 lg:px-12 bg-gradient-to-b from-[#0A1A35] to-black">
      <div className="max-w-6xl mx-auto">
        {/* Título */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Compara por tu cuenta:{' '}
            <span className="text-[#D4AF37]">tu dinero crece donde realmente trabaja</span>
          </h2>
        </div>

        {/* Comparación simplificada */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Banco Tradicional */}
          <div className="bg-gradient-to-br from-[#C5C7D0]/10 to-black/50 rounded-2xl p-8 border border-[#C5C7D0]/30">
            <div className="text-center space-y-4">
              <i className="ri-bank-line text-5xl text-[#C5C7D0]"></i>
              <h3 className="text-2xl font-bold text-[#C5C7D0]">Banco Tradicional</h3>
              <div className="py-6">
                <p className="text-6xl font-bold text-[#C5C7D0]">5.5%</p>
                <p className="text-[#C5C7D0]/70 mt-2">anual</p>
              </div>
              <p className="text-[#C5C7D0]/60 text-sm">
                Rendimiento promedio en cuentas de ahorro tradicionales
              </p>
            </div>
          </div>

          {/* Estrategias con Índices */}
          <div className="bg-gradient-to-br from-[#D4AF37]/20 to-black/50 rounded-2xl p-8 border border-[#D4AF37]/50 shadow-lg shadow-[#D4AF37]/20">
            <div className="text-center space-y-4">
              <i className="ri-line-chart-line text-5xl text-[#D4AF37]"></i>
              <h3 className="text-2xl font-bold text-[#D4AF37]">Estrategias con Índices</h3>
              <div className="py-6 space-y-3">
                <div>
                  <p className="text-2xl font-bold text-white">Conservador: <span className="text-[#D4AF37]">7%</span></p>
                </div>
                <div>
                  <p className="text-2xl font-bold text-white">Moderado: <span className="text-[#D4AF37]">9%</span></p>
                </div>
                <div>
                  <p className="text-2xl font-bold text-white">Agresivo: <span className="text-[#D4AF37]">12%</span></p>
                </div>
                <p className="text-[#D4AF37]/70 mt-2 text-sm">anual</p>
              </div>
              <p className="text-[#C5C7D0]/80 text-sm">
                Rendimientos históricos basados en índices globales
              </p>
            </div>
          </div>
        </div>

        {/* Nota aclaratoria */}
        <div className="mt-12 text-center">
          <p className="text-[#C5C7D0]/60 text-sm">
            <i className="ri-information-line text-[#D4AF37] mr-2"></i>
            Los rendimientos pasados no garantizan resultados futuros. Datos referenciales.
          </p>
        </div>
      </div>
    </section>
  );
}
